module.exports = __webpack_public_path__ + "static/media/rings.603c7aa2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/css_art/rings.gif
// module id = 110
// module chunks = 0